require('../bootstrap');
window.Vue = require('vue');

window.apiEndPoint = '/api/blog';
window.mediaRoot = `https://media.goodschool.hk`;
window.mediaAPI = `https://media.goodschool.hk/api/media`;

window.Vue = require('vue');
import vSelect from 'vue-select'
Vue.component('v-select', vSelect);
Vue.component('campus-news-school-filter', require('./CampusListSchoolSelect'));

const app = new Vue({
    el: '#campus'
});


// WEBPACK FOOTER //
// ./resources/js/campus/campus-app.js